var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAi = function SvgAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#807B7A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M3.5 10h2m-2 4h2m5-11v2m4-2v2m7 5h-2m2 4h-2m-5 7v-2m-4 2v-2m-4-14h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m3 4h6v6h-6z"
  })));
};
export { SvgAi as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuNSAxMEg1LjVNMy41IDE0SDUuNU0xMC41IDNWNU0xNC41IDNWNU0yMS41IDEwSDE5LjVNMjEuNSAxNEgxOS41TTE0LjUgMjFWMTlNMTAuNSAyMVYxOU02LjUgNUgxOC41QzE5LjA1MjMgNSAxOS41IDUuNDQ3NzIgMTkuNSA2VjE4QzE5LjUgMTguNTUyMyAxOS4wNTIzIDE5IDE4LjUgMTlINi41QzUuOTQ3NzIgMTkgNS41IDE4LjU1MjMgNS41IDE4VjZDNS41IDUuNDQ3NzIgNS45NDc3MiA1IDYuNSA1Wk05LjUgOUgxNS41VjE1SDkuNVY5WiIgc3Ryb2tlPSIjODA3QjdBIiBzdHJva2Utd2lkdGg9IjEuNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";